// Google's anchor ad (a fixed bar the auto-ads script puts at the bottom of the screen) is kept on every page
// (owner rule, Nov 1 2026: never remove or turn off ads). Anything of ours that is pinned to the bottom edge on a
// phone sits ABOVE it instead of under it, so the ad never covers a button, input, result or Download.
//
// measureAnchorAdHeight() reads the anchor's real height (it varies by creative); useAnchorAdOffset() publishes it
// as the CSS variable --anchor-h on <html> and sets data-anchor-ad while one is showing. 0 when there is none.

export const ANCHOR_CSS_VAR = "--anchor-h";
export const ANCHOR_ATTR = "data-anchor-ad";

/** Height in px of a bottom-anchored ad, 0 when none is showing (or it is a top anchor). */
export function measureAnchorAdHeight(doc: Document = document, viewportHeight: number = window.innerHeight): number {
  const nodes = doc.querySelectorAll<HTMLElement>(
    'ins[data-anchor-shown="true"], ins[data-anchor-status="displayed"], ins.adsbygoogle-noablate[data-anchor-status]',
  );
  let h = 0;
  nodes.forEach((el) => {
    const r = el.getBoundingClientRect();
    const style = el.ownerDocument.defaultView?.getComputedStyle(el);
    if (!r.height || style?.display === "none" || style?.visibility === "hidden") return;
    // bottom anchors touch the bottom edge of the viewport; a top anchor does not
    if (r.bottom >= viewportHeight - 2) h = Math.max(h, Math.round(r.height));
  });
  return h;
}
